import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  row: {
    marginBottom: theme.spacing(1),
    position: "relative",
  },
  paper: {
    padding: theme.spacing(2),
  },
  subtitle: {
    borderBottom: "1px solid " + theme.palette.divider,
    marginBottom: theme.spacing(2),
  },
  photoLabel: {
    marginRight: theme.spacing(1)
  },
  btnContainer: {
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1),
    borderTop: "1px solid " + theme.palette.divider,
  },
  resetBtn: {
    marginRight: theme.spacing(1)
  }
}));
export default styles;
